export default __webpack_public_path__ + "static/media/need_more.2c723a1e.svg";